const equipment = {
    nameEn: '',
    nameDe: '',
};

export const formInitialValues = {
    equipment,
};
